"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 */
var fbt = require("./fbt");

var init = require("./fbtInit");

var FbtTranslations = require("./FbtTranslations");

var GenderConst = require("./GenderConst");

var IntlVariations = require("./IntlVariations");

var IntlViewerContext = require("./IntlViewerContext");

var FbtPublic = {
  FbtTranslations: FbtTranslations,
  GenderConst: GenderConst,
  IntlVariations: IntlVariations,
  IntlViewerContext: IntlViewerContext,
  fbt: fbt,
  init: init
};
module.exports = FbtPublic;
